import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable()
export class CustomiseService {

  public config: any = {
    uiConfig: {
      va_font_family: '',
      va_position: 'right',
      va_font_size: 13,
      va_title_size: 15,
      va_avatar: '',
      va_brand_color: '#2081da',
      va_font_color: '#ffffff',
      is_launcher_text_visible: false,
      va_launcher_text: 'Welcome',
      va_title: 'Ask CIRA',
      va_query_hint:'Ask Something....',
      va_design: 'round',
      va_text_size: 'large',
      va_header_text_color: '#000000',
      va_header_icon_color: '#000000',
      va_body_color: '#ffffff',
      side_panel_header: '#EAEAEA',
      side_panel_text_icon: '#3D3D3D',
      side_panel_body: '#ffffff',
      side_panel_body_text: '#3D3D3D',
      va_body_shadow: {
        x_offset: '0',
        y_offset: '1',
        blur: '11',
        spread: '3',
        color: '#0000001f',
        shadow_type: 'Default'
      }
    },
    advanceConfig: {
      resizable: true,
      draggable: true,
      launcher: true,
      hideBranding: true,
      startOver: true,
      quickLink: true,
      favourite: true,
      liveAgent: false,
      speakOut: false,
      isChatHistory: false,
      exploreLibrary: false,
      conversational_feedback: true,
      custom_css: '',
      notification: false,
      showCopilotHeader: true,
      customised_avatar: false,
      //selectedQuickLink:''
    }
  };
  previewInitFlag = false;
  configName: any = 'name';

  constructor(private _http: HttpClient) { }

  // get customisation values
  getCustomisationValues(agentId) {
    return this._http.get(environment.va_service_api + 'ui_customization/' + agentId + '/get').pipe(
      map((response: any) => {
        console.log(response)
        if (response['content'] && response['content'].hasOwnProperty('uiConfig')) {
          this.config = response['content'];
          if (!response['content']['uiConfig'].hasOwnProperty('is_launcher_text_visible')) {
            this.config.uiConfig.is_launcher_text_visible = true;
          }
        } else {
          this.config.uiConfig.va_brand_color = response['content']["primary_color"];
          this.config.uiConfig.va_font_color = '#ffffff';
          this.config.uiConfig.va_avatar = response['content']["va_avatar"];
          this.config.uiConfig.va_title = response['content']["va_title"];
        }
        return response;
      }),
      catchError((err: any) => {
        console.log(err);
        throw err; // Re-throwing error to propagate it downstream
      })
    );
  }

  // set customisation values
  setCustomisationValues(agentId, params?) {
    return this._http.post(environment.va_service_api + 'ui_customization/' + agentId + '/set', { content: this.config })
  }

  // upload avatar
  uploadAvatar(agentId, optionId, file) {
    // console.log(file)
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this._http.post(environment.va_service_api + 'ui_customization/' + agentId + '/' + optionId + '/upload_avatar', formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    })
  }

  // Upload customisation assets.
  uploadAssets(agentId, folderName, fileName, file) {
    const formData: FormData = new FormData();
    formData.append('file', file, fileName);
    return this._http.post(environment.va_service_api + 'ui_customization/' + agentId + '/upload_ui_assets/' + folderName, formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    })
  }

  uploadZipFile(agentId, file) {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this._http.post(environment.va_service_api + 'ui_customization_editor/' + agentId + '/upload_custom_ui_zip', formData, {
      headers: new HttpHeaders().set('Content-Type', 'multipart/form-data'),
    })
  }

  getUILIbraryFilteredList(agentId, type) {
    return this._http.post(environment.va_service_api + 'ui-library/filter-ui-library/' + agentId, { 'ui_library_type': type })
  }

  lisUIOptions(agentId) {
    return this._http.get(environment.va_service_api + 'ui_customization/' + agentId + '/list_ui_option')
  }

  saveUIOptions(agentId, params) {
    return this._http.post(environment.va_service_api + 'ui_customization/' + agentId + '/save', params)
  }

  setAsDefault(agentId, optionId, params) {
    return this._http.put(environment.va_service_api + 'ui_customization/' + agentId + '/' + optionId + '/set_default',
     params )
  }

  deleteOption(agentId, optionId) {
    return this._http.delete(environment.va_service_api + 'ui_customization/' + agentId + '/' + optionId )
  }

  getOptionDetail(agentId, optionId) {
    return this._http.get(environment.va_service_api + 'ui_customization/' + agentId + '/' + optionId + '/list_details').pipe(
      map((response: any) => {
        if (response['result']['content'] && response['result']['content'].hasOwnProperty('uiConfig')) {
          this.config = response['result']['content'];
          if (!response['result']['content']['uiConfig'].hasOwnProperty('is_launcher_text_visible')){
            this.config.uiConfig.is_launcher_text_visible = true;
          }
          if(!this.config.uiConfig.va_body_shadow ){
            this.config.uiConfig.va_body_shadow= {
              x_offset: '0',
              y_offset: '1',
              blur: '11',
              spread: '3',
              color: '#a3a2a2',
              shadow_type: 'Default'
            }
          }
          if(!this.config.uiConfig.side_panel_header) {
            this.config.uiConfig.side_panel_header = '#EAEAEA'
          }
          if(!this.config.uiConfig.side_panel_text_icon) {
            this.config.uiConfig.side_panel_text_icon = '#3D3D3D'
          }
          if(!this.config.uiConfig.side_panel_body) {
            this.config.uiConfig.side_panel_body = '#FFFFFF'
          }
          if(!this.config.uiConfig.side_panel_body_text) {
            this.config.uiConfig.side_panel_body_text = '#3D3D3D'
          }
        }
        return response;
      }),
      catchError(err => {
        return err;
      })
    );
  }

  setOptionDetail(agentId, optionId, params?) {
    if(params && params.custom_css){
      this.config.advanceConfig.custom_css = params.custom_css;
    }
    
    return this._http.put(environment.va_service_api + 'ui_customization/' + agentId + '/' + optionId
     + '/update', { content: this.config })
  }

  updateOptionData(agentId, optionId, params) {
    return this._http.put(environment.va_service_api + 'ui_customization/' + agentId + '/' + optionId
     + '/basic_data_update', params)
  }

  getDefaultConfig(agentId) {
    return this._http.get(environment.va_service_api + 'ui_customization/' + agentId + '/default_ui')
  }

}
